import { Component, EventEmitter, Input, Output } from "@angular/core";
import { LISTHEADER_SELECTOR } from "../../../crossconcern/utilities/properties/selector.property";

@Component({
    selector: LISTHEADER_SELECTOR,
    templateUrl: "./listheader.component.html"
})

export class ListHeaderComponent {

    @Input() public viewLabel: string;
    @Input() public showSyncProducts: boolean;
    @Output() public onFiltersClicked: EventEmitter<{}> = new EventEmitter();
    @Output() public onSearchConfirmed: EventEmitter<string> = new EventEmitter();
    @Output() public onSyncProducts: EventEmitter<string> = new EventEmitter();

    constructor() {
        //
    }

    public onSearchConfirm($event) {
        this.onSearchConfirmed.emit($event);
    }

    public onFiltersClick() {
        this.onFiltersClicked.emit();
    }

    public syncProducts() {
        this.onSyncProducts.emit();
    }
}
